export const educationTheory = [
    {
        number: 1,
        text: "Правила дорожного движения"
    },
    {
        number: 2,
        text: "Основы безопасности вождения"
    },
    {
        number: 3,
        text: "Разбор сложных дорожных ситуаций"
    },
    {
        number: 4,
        text: "Устройство и обслуживание автомобиля"
    },
]

export const educationPractice = [
    {
        number: 1,
        text: "Отработка навыков на автодроме"
    },
    {
        number: 2,
        text: "Вождение в городских условиях"
    },
    {
        number: 3,
        text: "Разбор ошибок и сложных моментов"
    },
]